import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";

const Videos = () => {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "videos"));
        const videosData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setVideos(videosData);
      } catch (error) {
        console.error("❌ خطأ أثناء جلب الفيديوهات:", error);
      }
    };

    fetchVideos();
  }, []);

  return (
    <div id="videos" style={styles.videos}>
      <div className="mainTitle">
        <div className="lines">
          <div className="line"></div>
          <div className="line"></div>
          <div className="title">
            <h2>مكتبة الفيديوهات</h2>
          </div>
        </div>
      </div>
      <div style={styles.container}>
        <div style={styles.videosGrid}>
          {videos.length > 0 ? (
            videos.map((video) => (
              <div key={video.id} style={styles.videoCard}>
                <div style={styles.playerWrapper}>
                  <iframe
                    width="100%"
                    height="100%"
                    style={styles.iframe}
                    src={convertToEmbed(video.url)}
                    title={video.title}
                    frameBorder="0"
                    allow="accelerometer;clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
                <h3 style={styles.videoTitle}>{video.title}</h3>
              </div>
            ))
          ) : (
            <p style={{ textAlign: "center" }}>⏳ جاري تحميل الفيديوهات...</p>
          )}
        </div>
      </div>
    </div>
  );
};

// 🧠 دالة لتحويل رابط YouTube إلى رابط يمكن تضمينه
const convertToEmbed = (url) => {
  if (!url) return "";
  return url.replace("watch?v=", "embed/");
};

// 🎨 الأنماط
const styles = {
  videos: {
    padding: "100px 0",
    direction: "rtl",
  },
  mainTitle: {
    textAlign: "center",
    marginBottom: "40px",
  },
  lines: {
    display: "inline-block",
    position: "relative",
  },
  line: {
    width: "80px",
    height: "2px",
    background: "#c7a451",
    margin: "6px auto",
  },
  title: {
    textAlign: "center",
  },
  h2: {
    fontSize: "28px",
    color: "#333",
    margin: "10px 0",
  },
  container: {
    width: "90%",
    margin: "auto",
    paddingTop:"100px",
  },
  videosGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
    gap: "30px",
  },
  videoCard: {
    background: "#000",
    borderRadius: "10px",
    overflow: "hidden",
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.08)",
    transition: "all 0.3s ease",
  },
  playerWrapper: {
    position: "relative",
    paddingTop: "56.25%", // نسبة 16:9
  },
  iframe: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    border: "none",
  },
  videoTitle: {
    padding: "15px",
    fontSize: "18px",
    textAlign: "center",
    background: "linear-gradient(90deg, #FDC977, #BD9D63, #FFE6AD, #AE8443)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
};

export default Videos;
